// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/transparent.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/background-expanse.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../img/background-expanse-overlay.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../img/anaphora_by_cetrez.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../img/background-secure.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../img/secure-logo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../img/spritesheet.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../img/button-working.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body, div, span, object, iframe,
h1, h2, h3, h4, h5, h6, p, pre,
a, img, b, u, i, dl, dt, dd, ol, ul, li,
form, label, table, tbody, tfoot, thead, tr, th
canvas, embed, audio, video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

table {
  border-spacing: 0;
  border-collapse: collapse;
}

b {
  font-weight: bold;
}

input, textarea {
  margin: 0;
  padding: 0;
  border: 0;
}

/* -------------------------------------------------------------------------- */


html {
  line-height: 0;
}
html, a, input, textarea {
  color: #ff00ff;
}
html, input, textarea {
  font-size: 20px;
  font-family: serif;
}
::-ms-clear {
  width: 0;
}
::-ms-reveal {
  width: 0;
}

::selection {
  background: #007fc8;
  color: #ffffff;
}
::-moz-selection {
  background: #007fc8;
  color: #ffffff;
}

/* -------------------------------------------------------------------------- */

html {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.selectable {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;

  -webkit-user-select: element;
  -moz-user-select: element;
  -ms-user-select: element;
  user-select: element;
}

#content, #popups {
  white-space: pre-wrap;
}

.nobr {
  white-space: pre;
}

/* -------------------------------------------------------------------------- */

html {
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -moz-text-size-adjust: 100%;
  text-size-adjust: 100%;
}

object, embed {
  display: block;
}

:focus {
  outline: 0;
}

/* -------------------------------------------------------------------------- */

html, body {
  height: 100%;
}
html {
  overflow-y: scroll;
}

html.iescroll {
  overflow-y: auto;
}
html.iescroll {
  -ms-overflow-style: -ms-autohiding-scrollbar;
}
html.iescroll > body > * {
  -ms-overflow-style: scrollbar;
}

/* -------------------------------------------------------------------------- */

#c5-core-block-input {
  display: none;
  position: fixed;
  z-index: 50000;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  cursor: progress;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

/* -------------------------------------------------------------------------- */

body.c5-style-login {
  background: #d6dcdf url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center top;
}

/* A session from the platform starts on the overview's background, the UI library's colors.background */
body.c5-style-platform {
  background: #f5f5f5;
}

.loExpanseOverlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 177px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center top repeat-x;
}

.loLoginAnaphora {
  position: absolute;
  top: 30px;
  left: 30px;
  width: 128px;
  height: 28px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) top left no-repeat;
}

.loSecureBackground {
  position: absolute;
  right: 0;
  left: -4096px;
  height: 100%;
  background: #313131 url(${___CSS_LOADER_URL_REPLACEMENT_4___}) right top;
}

.loSecureLogo {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat;
  height: 37px;
}


.c5-rounded-border {
  position: absolute;
  top: 0px; left: 0px; bottom: 0px; right: 0px;
  border-width: 1.01px;
  border-style: solid;
  border-radius: 2px;
  border-color: transparent;
}


.c5-login-textfield {
  position: relative;
  padding: 1px;
}
.c5-login-textfield > input {
  font: 12px/12px Arial, Helvetica, sans-serif;
  height: 12px;
  display: block;
}
.c5-login-textfield > .hint {
  position: absolute;
  color: #b0b2bf;
  background: none;
  padding: 11px 0 0 11px;
}
.c5-login-textfield > .field {
  position: relative;
  color: #333333;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  padding: 11px 11px 11px 11px;
}

.c5-login-textfield.readonly.copy > .c5-rounded-border {
  border-color: #a0d0eb;
  background: #dfecf3;
}
.c5-login-textfield.readonly.copy > .field {
  color: #2c80b0;
}
.c5-login-textfield.readonly.copy.focus > .c5-rounded-border {
  border-color: #4ab5f2;
}

.c5-login-textfield.nonempty > .hint { display: none; }

.c5-login-textfield > .c5-rounded-border { background: #ffffff; border-color: #ffffff; }
.c5-login-textfield.focus > .c5-rounded-border { border-color: #ffffff; }
.c5-login-textfield.focus > .hint { color: #4ab5f2; }
.c5-login-textfield.error > .hint { color: #f14a4a; }




.c5-login-button {
  position: relative;
  cursor: pointer;
  display: inline-block;
}
.c5-login-button.disabled {
  cursor: default;
}
.c5-login-button > div {
  pointer-events: none;
}
.c5-login-button > .icon {
  position: absolute;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  height: 17px;
  width: 17px;
}
.c5-login-button > .label {
  position: relative;
  overflow: hidden;
  left: 0;
  right: 0;
  font: bold 11px/12px Arial, Helvetica, sans-serif;
  white-space: nowrap;
  text-transform: uppercase;
}
.c5-login-button > .activity {
  display: none;
  position: absolute;
  top: 49.9%;
  height: 5px;
  margin-top: -2px;
  right: 0;
  left: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat: no-repeat;
}
.c5-login-button.working > .icon, .c5-login-button.working > .label {
  visibility: hidden;
}
.c5-login-button.working > .activity {
  display: block;
}


.c5-login-button { height: 36px; }
.c5-login-button > .label { top: 12px; text-align: center; color: #ffffff; }

.c5-login-button.color-theme > .activity { background-position: center -1px; }
.c5-login-button.color-theme > .c5-rounded-border { background: #48ade7; border-color: #48ade7; }
.c5-login-button.color-theme:hover > .c5-rounded-border { background: #32a3e4; border-color: #32a3e4; }
`, "",{"version":3,"sources":["webpack://./src/assets/css/login.css"],"names":[],"mappings":"AAAA;;;;;EAKE,SAAS;EACT,UAAU;EACV,SAAS;EACT,eAAe;EACf,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA,+EAA+E;;;AAG/E;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,+EAA+E;;AAE/E;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;;EAEjB,4BAA4B;EAC5B,yBAAyB;EACzB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,+EAA+E;;AAE/E;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA,+EAA+E;;AAE/E;EACE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,6BAA6B;AAC/B;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,mDAAuC;AACzC;;AAEA,+EAA+E;;AAE/E;EACE,sEAAiE;AACnE;;AAEA,wGAAwG;AACxG;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,uEAA0E;AAC5E;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,sEAAiE;AACnE;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,YAAY;EACZ,qEAA+D;AACjE;;AAEA;EACE,6DAAiD;EACjD,YAAY;AACd;;;AAGA;EACE,kBAAkB;EAClB,QAAQ,EAAE,SAAS,EAAE,WAAW,EAAE,UAAU;EAC5C,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;;AAGA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,4CAA4C;EAC5C,YAAY;EACZ,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,mDAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;;AAEA,uCAAuC,aAAa,EAAE;;AAEtD,2CAA2C,mBAAmB,EAAE,qBAAqB,EAAE;AACvF,iDAAiD,qBAAqB,EAAE;AACxE,oCAAoC,cAAc,EAAE;AACpD,oCAAoC,cAAc,EAAE;;;;;AAKpD;EACE,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,yDAA6C;EAC7C,YAAY;EACZ,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,iDAAiD;EACjD,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,QAAQ;EACR,OAAO;EACP,yDAAgD;EAChD,4BAA4B;AAC9B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;;;AAGA,mBAAmB,YAAY,EAAE;AACjC,4BAA4B,SAAS,EAAE,kBAAkB,EAAE,cAAc,EAAE;;AAE3E,2CAA2C,gCAAgC,EAAE;AAC7E,oDAAoD,mBAAmB,EAAE,qBAAqB,EAAE;AAChG,0DAA0D,mBAAmB,EAAE,qBAAqB,EAAE","sourcesContent":["html, body, div, span, object, iframe,\nh1, h2, h3, h4, h5, h6, p, pre,\na, img, b, u, i, dl, dt, dd, ol, ul, li,\nform, label, table, tbody, tfoot, thead, tr, th\ncanvas, embed, audio, video {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n}\n\ntable {\n  border-spacing: 0;\n  border-collapse: collapse;\n}\n\nb {\n  font-weight: bold;\n}\n\ninput, textarea {\n  margin: 0;\n  padding: 0;\n  border: 0;\n}\n\n/* -------------------------------------------------------------------------- */\n\n\nhtml {\n  line-height: 0;\n}\nhtml, a, input, textarea {\n  color: #ff00ff;\n}\nhtml, input, textarea {\n  font-size: 20px;\n  font-family: serif;\n}\n::-ms-clear {\n  width: 0;\n}\n::-ms-reveal {\n  width: 0;\n}\n\n::selection {\n  background: #007fc8;\n  color: #ffffff;\n}\n::-moz-selection {\n  background: #007fc8;\n  color: #ffffff;\n}\n\n/* -------------------------------------------------------------------------- */\n\nhtml {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.selectable {\n  -webkit-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  user-select: text;\n\n  -webkit-user-select: element;\n  -moz-user-select: element;\n  -ms-user-select: element;\n  user-select: element;\n}\n\n#content, #popups {\n  white-space: pre-wrap;\n}\n\n.nobr {\n  white-space: pre;\n}\n\n/* -------------------------------------------------------------------------- */\n\nhtml {\n  -webkit-text-size-adjust: 100%;\n  -ms-text-size-adjust: 100%;\n  -moz-text-size-adjust: 100%;\n  text-size-adjust: 100%;\n}\n\nobject, embed {\n  display: block;\n}\n\n:focus {\n  outline: 0;\n}\n\n/* -------------------------------------------------------------------------- */\n\nhtml, body {\n  height: 100%;\n}\nhtml {\n  overflow-y: scroll;\n}\n\nhtml.iescroll {\n  overflow-y: auto;\n}\nhtml.iescroll {\n  -ms-overflow-style: -ms-autohiding-scrollbar;\n}\nhtml.iescroll > body > * {\n  -ms-overflow-style: scrollbar;\n}\n\n/* -------------------------------------------------------------------------- */\n\n#c5-core-block-input {\n  display: none;\n  position: fixed;\n  z-index: 50000;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: hidden;\n  cursor: progress;\n  background: url(../img/transparent.png);\n}\n\n/* -------------------------------------------------------------------------- */\n\nbody.c5-style-login {\n  background: #d6dcdf url(../img/background-expanse.png) center top;\n}\n\n/* A session from the platform starts on the overview's background, the UI library's colors.background */\nbody.c5-style-platform {\n  background: #f5f5f5;\n}\n\n.loExpanseOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 177px;\n  background: url(../img/background-expanse-overlay.png) center top repeat-x;\n}\n\n.loLoginAnaphora {\n  position: absolute;\n  top: 30px;\n  left: 30px;\n  width: 128px;\n  height: 28px;\n  background: url(../img/anaphora_by_cetrez.svg) top left no-repeat;\n}\n\n.loSecureBackground {\n  position: absolute;\n  right: 0;\n  left: -4096px;\n  height: 100%;\n  background: #313131 url(../img/background-secure.png) right top;\n}\n\n.loSecureLogo {\n  background: url(../img/secure-logo.png) no-repeat;\n  height: 37px;\n}\n\n\n.c5-rounded-border {\n  position: absolute;\n  top: 0px; left: 0px; bottom: 0px; right: 0px;\n  border-width: 1.01px;\n  border-style: solid;\n  border-radius: 2px;\n  border-color: transparent;\n}\n\n\n.c5-login-textfield {\n  position: relative;\n  padding: 1px;\n}\n.c5-login-textfield > input {\n  font: 12px/12px Arial, Helvetica, sans-serif;\n  height: 12px;\n  display: block;\n}\n.c5-login-textfield > .hint {\n  position: absolute;\n  color: #b0b2bf;\n  background: none;\n  padding: 11px 0 0 11px;\n}\n.c5-login-textfield > .field {\n  position: relative;\n  color: #333333;\n  background: url(../img/transparent.png);\n  padding: 11px 11px 11px 11px;\n}\n\n.c5-login-textfield.readonly.copy > .c5-rounded-border {\n  border-color: #a0d0eb;\n  background: #dfecf3;\n}\n.c5-login-textfield.readonly.copy > .field {\n  color: #2c80b0;\n}\n.c5-login-textfield.readonly.copy.focus > .c5-rounded-border {\n  border-color: #4ab5f2;\n}\n\n.c5-login-textfield.nonempty > .hint { display: none; }\n\n.c5-login-textfield > .c5-rounded-border { background: #ffffff; border-color: #ffffff; }\n.c5-login-textfield.focus > .c5-rounded-border { border-color: #ffffff; }\n.c5-login-textfield.focus > .hint { color: #4ab5f2; }\n.c5-login-textfield.error > .hint { color: #f14a4a; }\n\n\n\n\n.c5-login-button {\n  position: relative;\n  cursor: pointer;\n  display: inline-block;\n}\n.c5-login-button.disabled {\n  cursor: default;\n}\n.c5-login-button > div {\n  pointer-events: none;\n}\n.c5-login-button > .icon {\n  position: absolute;\n  background-image: url(../img/spritesheet.png);\n  height: 17px;\n  width: 17px;\n}\n.c5-login-button > .label {\n  position: relative;\n  overflow: hidden;\n  left: 0;\n  right: 0;\n  font: bold 11px/12px Arial, Helvetica, sans-serif;\n  white-space: nowrap;\n  text-transform: uppercase;\n}\n.c5-login-button > .activity {\n  display: none;\n  position: absolute;\n  top: 49.9%;\n  height: 5px;\n  margin-top: -2px;\n  right: 0;\n  left: 0;\n  background-image: url(../img/button-working.gif);\n  background-repeat: no-repeat;\n}\n.c5-login-button.working > .icon, .c5-login-button.working > .label {\n  visibility: hidden;\n}\n.c5-login-button.working > .activity {\n  display: block;\n}\n\n\n.c5-login-button { height: 36px; }\n.c5-login-button > .label { top: 12px; text-align: center; color: #ffffff; }\n\n.c5-login-button.color-theme > .activity { background-position: center -1px; }\n.c5-login-button.color-theme > .c5-rounded-border { background: #48ade7; border-color: #48ade7; }\n.c5-login-button.color-theme:hover > .c5-rounded-border { background: #32a3e4; border-color: #32a3e4; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
